import * as React from "react";
const Calender = (props) => (
  <svg
    width={33}
    height={32}
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22.8333 4.7465V2.6665C22.8333 2.11984 22.38 1.6665 21.8333 1.6665C21.2866 1.6665 20.8333 2.11984 20.8333 2.6665V4.6665H12.1666V2.6665C12.1666 2.11984 11.7133 1.6665 11.1666 1.6665C10.62 1.6665 10.1666 2.11984 10.1666 2.6665V4.7465C6.56665 5.07983 4.81998 7.2265 4.55331 10.4132C4.52665 10.7998 4.84665 11.1198 5.21998 11.1198H27.78C28.1666 11.1198 28.4866 10.7865 28.4466 10.4132C28.18 7.2265 26.4333 5.07983 22.8333 4.7465Z"
      fill="#292D32"
    />
    <path
      d="M22.8333 4.7465V2.6665C22.8333 2.11984 22.38 1.6665 21.8333 1.6665C21.2866 1.6665 20.8333 2.11984 20.8333 2.6665V4.6665H12.1666V2.6665C12.1666 2.11984 11.7133 1.6665 11.1666 1.6665C10.62 1.6665 10.1666 2.11984 10.1666 2.6665V4.7465C6.56665 5.07983 4.81998 7.2265 4.55331 10.4132C4.52665 10.7998 4.84665 11.1198 5.21998 11.1198H27.78C28.1666 11.1198 28.4866 10.7865 28.4466 10.4132C28.18 7.2265 26.4333 5.07983 22.8333 4.7465Z"
      fill="url(#paint0_linear_3639_300866)"
    />
    <g opacity={0.4}>
      <path
        d="M28.5 14.4531V16.7731C28.5 17.5864 27.78 18.2131 26.98 18.0798C26.6067 18.0265 26.22 17.9864 25.8333 17.9864C21.7933 17.9864 18.5 21.2798 18.5 25.3198C18.5 25.9331 18.74 26.7865 18.9933 27.5598C19.2867 28.4265 18.6467 29.3198 17.7267 29.3198H11.1667C6.5 29.3198 4.5 26.6531 4.5 22.6531V14.4398C4.5 13.7064 5.1 13.1064 5.83333 13.1064H27.1667C27.9 13.1198 28.5 13.7198 28.5 14.4531Z"
        fill="#292D32"
      />
      <path
        d="M28.5 14.4531V16.7731C28.5 17.5864 27.78 18.2131 26.98 18.0798C26.6067 18.0265 26.22 17.9864 25.8333 17.9864C21.7933 17.9864 18.5 21.2798 18.5 25.3198C18.5 25.9331 18.74 26.7865 18.9933 27.5598C19.2867 28.4265 18.6467 29.3198 17.7267 29.3198H11.1667C6.5 29.3198 4.5 26.6531 4.5 22.6531V14.4398C4.5 13.7064 5.1 13.1064 5.83333 13.1064H27.1667C27.9 13.1198 28.5 13.7198 28.5 14.4531Z"
        fill="url(#paint1_linear_3639_300866)"
      />
    </g>
    <path
      d="M25.8333 20C22.8867 20 20.5 22.3867 20.5 25.3333C20.5 26.3333 20.78 27.28 21.2733 28.08C22.1933 29.6267 23.8867 30.6667 25.8333 30.6667C27.78 30.6667 29.4733 29.6267 30.3933 28.08C30.8867 27.28 31.1667 26.3333 31.1667 25.3333C31.1667 22.3867 28.78 20 25.8333 20ZM28.5933 24.76L25.7533 27.3867C25.5667 27.56 25.3133 27.6533 25.0733 27.6533C24.82 27.6533 24.5667 27.56 24.3667 27.36L23.0467 26.04C22.66 25.6533 22.66 25.0133 23.0467 24.6267C23.4333 24.24 24.0733 24.24 24.46 24.6267L25.1 25.2667L27.2333 23.2933C27.6333 22.92 28.2733 22.9467 28.6467 23.3467C29.02 23.7467 28.9933 24.3733 28.5933 24.76Z"
      fill="#292D32"
    />
    <path
      d="M25.8333 20C22.8867 20 20.5 22.3867 20.5 25.3333C20.5 26.3333 20.78 27.28 21.2733 28.08C22.1933 29.6267 23.8867 30.6667 25.8333 30.6667C27.78 30.6667 29.4733 29.6267 30.3933 28.08C30.8867 27.28 31.1667 26.3333 31.1667 25.3333C31.1667 22.3867 28.78 20 25.8333 20ZM28.5933 24.76L25.7533 27.3867C25.5667 27.56 25.3133 27.6533 25.0733 27.6533C24.82 27.6533 24.5667 27.56 24.3667 27.36L23.0467 26.04C22.66 25.6533 22.66 25.0133 23.0467 24.6267C23.4333 24.24 24.0733 24.24 24.46 24.6267L25.1 25.2667L27.2333 23.2933C27.6333 22.92 28.2733 22.9467 28.6467 23.3467C29.02 23.7467 28.9933 24.3733 28.5933 24.76Z"
      fill="url(#paint2_linear_3639_300866)"
    />
    <path
      d="M11.8333 19.9999C11.4867 19.9999 11.14 19.8532 10.8867 19.6132C10.6467 19.3599 10.5 19.0132 10.5 18.6666C10.5 18.3199 10.6467 17.9732 10.8867 17.7199C11.1933 17.4132 11.66 17.2665 12.1 17.3599C12.18 17.3732 12.26 17.3999 12.34 17.4399C12.42 17.4665 12.5 17.5066 12.58 17.5599C12.6467 17.6132 12.7133 17.6666 12.78 17.7199C13.02 17.9732 13.1667 18.3199 13.1667 18.6666C13.1667 19.0132 13.02 19.3599 12.78 19.6132C12.7133 19.6665 12.6467 19.7199 12.58 19.7732C12.5 19.8265 12.42 19.8666 12.34 19.8932C12.26 19.9332 12.18 19.9599 12.1 19.9732C12.0067 19.9866 11.9133 19.9999 11.8333 19.9999Z"
      fill="#292D32"
    />
    <path
      d="M11.8333 19.9999C11.4867 19.9999 11.14 19.8532 10.8867 19.6132C10.6467 19.3599 10.5 19.0132 10.5 18.6666C10.5 18.3199 10.6467 17.9732 10.8867 17.7199C11.1933 17.4132 11.66 17.2665 12.1 17.3599C12.18 17.3732 12.26 17.3999 12.34 17.4399C12.42 17.4665 12.5 17.5066 12.58 17.5599C12.6467 17.6132 12.7133 17.6666 12.78 17.7199C13.02 17.9732 13.1667 18.3199 13.1667 18.6666C13.1667 19.0132 13.02 19.3599 12.78 19.6132C12.7133 19.6665 12.6467 19.7199 12.58 19.7732C12.5 19.8265 12.42 19.8666 12.34 19.8932C12.26 19.9332 12.18 19.9599 12.1 19.9732C12.0067 19.9866 11.9133 19.9999 11.8333 19.9999Z"
      fill="url(#paint3_linear_3639_300866)"
    />
    <path
      d="M16.5001 20.0001C16.1534 20.0001 15.8067 19.8534 15.5534 19.6134C15.3134 19.3601 15.1667 19.0134 15.1667 18.6668C15.1667 18.3201 15.3134 17.9734 15.5534 17.7201C16.0601 17.2268 16.9534 17.2268 17.4467 17.7201C17.6867 17.9734 17.8334 18.3201 17.8334 18.6668C17.8334 19.0134 17.6867 19.3601 17.4467 19.6134C17.1934 19.8534 16.8467 20.0001 16.5001 20.0001Z"
      fill="#292D32"
    />
    <path
      d="M16.5001 20.0001C16.1534 20.0001 15.8067 19.8534 15.5534 19.6134C15.3134 19.3601 15.1667 19.0134 15.1667 18.6668C15.1667 18.3201 15.3134 17.9734 15.5534 17.7201C16.0601 17.2268 16.9534 17.2268 17.4467 17.7201C17.6867 17.9734 17.8334 18.3201 17.8334 18.6668C17.8334 19.0134 17.6867 19.3601 17.4467 19.6134C17.1934 19.8534 16.8467 20.0001 16.5001 20.0001Z"
      fill="url(#paint4_linear_3639_300866)"
    />
    <path
      d="M11.8333 24.6667C11.4867 24.6667 11.14 24.52 10.8867 24.28C10.6467 24.0266 10.5 23.68 10.5 23.3333C10.5 22.9867 10.6467 22.64 10.8867 22.3867C11.02 22.2667 11.1533 22.1733 11.3267 22.1066C11.82 21.8933 12.4067 22.0133 12.78 22.3867C13.02 22.64 13.1667 22.9867 13.1667 23.3333C13.1667 23.68 13.02 24.0266 12.78 24.28C12.5267 24.52 12.18 24.6667 11.8333 24.6667Z"
      fill="#292D32"
    />
    <path
      d="M11.8333 24.6667C11.4867 24.6667 11.14 24.52 10.8867 24.28C10.6467 24.0266 10.5 23.68 10.5 23.3333C10.5 22.9867 10.6467 22.64 10.8867 22.3867C11.02 22.2667 11.1533 22.1733 11.3267 22.1066C11.82 21.8933 12.4067 22.0133 12.78 22.3867C13.02 22.64 13.1667 22.9867 13.1667 23.3333C13.1667 23.68 13.02 24.0266 12.78 24.28C12.5267 24.52 12.18 24.6667 11.8333 24.6667Z"
      fill="url(#paint5_linear_3639_300866)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_3639_300866"
        x1={4.55139}
        y1={11.1198}
        x2={11.0183}
        y2={-5.22886}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9DE4" />
        <stop offset={1} stopColor="#FFEAF6" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_3639_300866"
        x1={4.49963}
        y1={29.3197}
        x2={19.5411}
        y2={7.05424}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9DE4" />
        <stop offset={1} stopColor="#FFEAF6" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_3639_300866"
        x1={20.4998}
        y1={30.6666}
        x2={31.1665}
        y2={19.9999}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9DE4" />
        <stop offset={1} stopColor="#FFEAF6" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_3639_300866"
        x1={10.5}
        y1={19.9999}
        x2={13.1678}
        y2={17.3332}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9DE4" />
        <stop offset={1} stopColor="#FFEAF6" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_3639_300866"
        x1={15.1667}
        y1={20.0001}
        x2={17.8167}
        y2={17.3334}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9DE4" />
        <stop offset={1} stopColor="#FFEAF6" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_3639_300866"
        x1={10.5}
        y1={24.6666}
        x2={13.1652}
        y2={22}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF9DE4" />
        <stop offset={1} stopColor="#FFEAF6" />
      </linearGradient>
    </defs>
  </svg>
);
export default Calender;
